import React from 'react'
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts'

const Chart = ({ data }) => {
  return (
    <LineChart
      width={730}
      height={350}
      data={data}
    >
      <XAxis dataKey="label" />
      <YAxis />
      <CartesianGrid strokeDasharray="3 3" />
      <Tooltip />
      <Legend />
      <Line type="monotone" dataKey="オーナー" stroke="#2c3e50" activeDot={{r: 8}}/>
      <Line type="monotone" dataKey="物件" stroke="#7f8c8d" activeDot={{r: 8}}/>
      <Line type="monotone" dataKey="入居者" stroke="#95a5a6" activeDot={{r: 8}}/>
    </LineChart>
  )
}

export default Chart



// WEBPACK FOOTER //
// ./src/components/_common/Chart.js